import { Text } from '../../atoms/text/text.atom';
import { ThankYouContainer } from '../../atoms/thank-you-container/thank-you-container.atom';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const ThankYouFooter = () => {
  const { t } = useTranslation();
  return (
    <ThankYouContainer padding="1.5rem 0" textAlign="center">
      <Text align="center" size="0.875rem" color="#6b7280">
        © 2025 {t('vendepayRights')}
      </Text>
    </ThankYouContainer>
  );
};
